import '../Scss/app.scss';

// Components
import events from './helpers/events';
import general from './core/general';
import header from './core/header';
const modules = [general, events, header];
modules.forEach(module => {
  module();
});
const components = [{
  el: '.ce-tabs',
  fileName: 'vendors/tabs'
}, {
  el: '.accordion',
  fileName: 'vendors/accordion'
}, {
  el: '.dropdown',
  fileName: 'vendors/dropdown'
}, {
  el: '.carousel',
  fileName: 'components/carousel'
}, {
  el: '.menu-pages',
  fileName: 'components/menu-pages'
}, {
  el: '.tx-powermail',
  fileName: 'components/powermail'
}, {
  el: '.media__video--player',
  fileName: 'components/video'
}, {
  el: '.js-cmp-open-settings',
  fileName: 'components/cookie-consent'
}, {
  el: '.ce-map',
  fileName: 'components/locations-map'
}, {
  el: '.ce-modelviewer__model',
  fileName: 'components/model-viewer'
}, {
  el: '.ce-teaser-bg--parallax',
  fileName: 'components/teaser-parallax'
}, {
  el: '.ce-textpic--animate',
  fileName: 'components/textpic'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});